module.exports = __webpack_public_path__ + "website/img/zj3.2c4fde9d.png";